export default "__VITE_ASSET__dOWh7x$H__"